import { gql } from '@lcs/shared/api';

export const getLocationsQuery = gql`
   query GetLocations($first: Int!, $filters: String, $after: String, $orderingOptions: [OrderingOption!]) {
      locationsConnection(first: $first, filters: $filters, after: $after, orderingOptions: $orderingOptions) {
         totalCount
         pageInfo {
            hasNextPage
            endCursor
            hasPreviousPage
            startCursor
         }
         items {
            locationId
            name
            address
            city
            state
            postalCode
            comment
            createDate
            createUser {
               name
            }
            updateDate
            updateUser {
               name
            }
         }
      }
   }
`;
